import { css } from 'styled-components';
import { generateMedia } from 'styled-media-query'



export enum ColorVariant {
  ACCENT_BLUE_1 = 'AccentBlue1',
  ACCENT_BLUE_2 = 'AccentBlue2',
  BLUE_1 = 'Blue1',
  LIGHT_BLUE_1 = 'LightBlue1',
  LIGHT_BLUE_2 = 'LightBlue2',
  BLUE_3_NA = 'Blue3NA',
  ACCENT_RED_1 = 'AccentRed1',
  RED_2_NA = 'Red2NA',
  ACCENT_GREEN_1 = 'AccentGreen1',
  GRAY_1 = 'Gray1',
  SECONDARY_GRAY_1 = 'SecondaryGray1',
  SECONDARY_GRAY_2 = 'SecondaryGray2',
  SECONDARY_GRAY_3 = 'SecondaryGray3',
  SECONDARY_GRAY_4 = 'SecondaryGray4',
  SECONDARY_GRAY_5 = 'SecondaryGray5',
  SECONDARY_GRAY_9 = 'SecondaryGray9',
  // 10 и 11 NA не имеют названия в дизайн системе
  SECONDARY_GRAY_10_NA = 'SecondaryGray10NA',
  SECONDARY_GRAY_11_NA = 'SecondaryGray11NA',
  SECONDARY_GRAY_12 = 'SecondaryGray12',
  PRIMARY_WHITE = 'PrimaryWhite',
  PRIMARY_STEEL = 'PrimarySteel',
  PRIMARY_BLACK = 'PrimaryBlack',
  PRIMARY_BLUE_100 = 'PrimaryBlue100',
  ALERT_SUCCESS = 'AlertSuccess',
  BACKGROUND_FILL_LIGHT = 'BackgroundFillLight',
  CARD_BORDER_COLOR = 'CardBorderColor',
  OVERLAY_BACKGROUND = 'OverlayBackground',
  SURFACE_BACKGROUND_PRIMARY = 'SurfaceBackgroundPrimary',
  SURFACE_BACKGROUND_SECONDARY = 'SurfaceBackgroundSecondary',
  BORDER_PRIMARY = 'BorderPrimary',
  BORDER_SECONDARY = 'BorderSecondary',
  BORDER_TERTIARY = 'BorderTertiary',
  BORDER_PASTEL_BLUE_PRIMARY_2 = 'BorderPastelBluePrimary2',
  BORDER_PASTEL_BLUE_SECONDARY_2 = 'BorderPastelBlueSecondary2',
  BORDER_PASTEL_BLUE_TERTIARY_2 = 'BorderPastelBlueTertiary2',
  BORDER_BLUE= 'BorderBlue',
  BORDER_RED = 'BorderRed',
  TEXT_NEUTRAL_TEXT_100 = 'TextNeutralText100',
  TEXT_NEUTRAL_TEXT_50 = 'TextNeutralText50',
  TEXT_ACCENT_RED_100 = 'TextAccentRed100',
  TEXT_ACCENT_RED_50 = 'TextAccentRed50',
  TEXT_ACCENT_GREEN_100 = 'TextAccentGreen100',
  TEXT_ACCENT_GREEN_50 = 'TextAccentGreen50',
  TEXT_ACCENT_BLUE_COBALT_100 = 'TextAccentBlueCobolt100',
  TEXT_ACCENT_BLUE_COBALT_50 = 'TextAccentBlueCobolt50',
  TEXT_PERMANENT_BLACK = 'TextPermanentBlack',
  TEXT_PERMANENT_GRAY = 'TextPermanentGray',
  TEXT_PERMANENT_WHITE = 'TextPermanentWhite',
  TEXT_PerMANENT_BLUE = 'TextPermanentBlue',
  NEUTRAL_PRIMARY = 'NeutralPrimary',
  NEUTRAL_SECONDARY = 'NeutralSecondary',
  NEUTRAL_GREY_100 = 'NeutralGrey100',
  NEUTRAL_GREY_85 = 'NeutralGrey85',
  NEUTRAL_GREY_60 = 'NeutralGrey60',
  NEUTRAL_GREY_45 = 'NeutralGrey45',
  NEUTRAL_GREY_30 = 'NeutralGrey30',
  NEUTRAL_GREY_15 = 'NeutralGrey15',
  NEUTRAL_BLUE_01 = 'NeutralBlue01',
  NEUTRAL_BLUE_02 = 'NeutralBlue02',
  NEUTRAL_BLUE_03 = 'NeutralBlue03',
  ACCENT_PRIMARY_BLUE_PRIMARY_01 = 'AccentPrimaryBluePrimary01',
  ACCENT_PRIMARY_BLUE_PRIMARY_02 = 'AccentPrimaryBluePrimary02',
  ACCENT_PRIMARY_BLUE_PRIMARY_03 = 'AccentPrimaryBluePrimary03',
  ACCENT_PRIMARY_BLUE_PRIMARY_04 = 'AccentPrimaryBluePrimary04',
  ACCENT_PRIMARY_BLUE_PRIMARY_05 = 'AccentPrimaryBluePrimary05',
  ACCENT_PRIMARY_BLUE_COBOLT_01 = 'AccentPrimaryBlueCobolt01',
  ACCENT_PRIMARY_BLUE_COBOLT_02 = 'AccentPrimaryBlueCobolt02',
  ACCENT_PRIMARY_BLUE_COBOLT_03 = 'AccentPrimaryBlueCobolt03',
  ACCENT_PRIMARY_BLUE_COBOLT_04 = 'AccentPrimaryBlueCobolt04',
  ACCENT_PRIMARY_BLUE_COBOLT_05 = 'AccentPrimaryBlueCobolt05',
  ACCENT_PRIMARY_BLUE_MIDNIGHT_01 = 'AccentPrimaryBlueMidnight01',
  ACCENT_PRIMARY_BLUE_MIDNIGHT_02 = 'AccentPrimaryBlueMidnight02',
  ACCENT_PRIMARY_BLUE_MIDNIGHT_03 = 'AccentPrimaryBlueMidnight03',
  ACCENT_PRIMARY_BLUE_MIDNIGHT_04 = 'AccentPrimaryBlueMidnight04',
  ACCENT_PRIMARY_BLUE_MIDNIGHT_05 = 'AccentPrimaryBlueMidnight05',
  ACCENT_PRIMARY_RED_PRIMARY = 'AccentPrimaryRedPrimary',
  ACCENT_PRIMARY_RED_SECONDARY = 'AccentPrimaryRedSecondary',
  ACCENT_PRIMARY_GREEN = 'AccentPrimaryGreen',
  ACCENT_PRIMARY_ORANGE = 'AccentPrimaryOrange',
  ACCENT_SECONDARY_BURGUNDY_01 = 'AccentSecondaryBurgundy01',
  ACCENT_SECONDARY_BURGUNDY_02 = 'AccentSecondaryBurgundy02',
  ACCENT_SECONDARY_BURGUNDY_03 = 'AccentSecondaryBurgundy03',
  ACCENT_SECONDARY_BURGUNDY_04 = 'AccentSecondaryBurgundy04',
  ACCENT_SECONDARY_LAVENDER_01 = 'AccentSecondaryLavender01',
  ACCENT_SECONDARY_LAVENDER_02 = 'AccentSecondaryLavender02',
  ACCENT_SECONDARY_LAVENDER_03 = 'AccentSecondaryLavender03',
  ACCENT_SECONDARY_LAVENDER_04 = 'AccentSecondaryLavender04',
  ACCENT_SECONDARY_EMERALD_01 = 'AccentSecondaryEmerald01',
  ACCENT_SECONDARY_EMERALD_02 = 'AccentSecondaryEmerald02',
  ACCENT_SECONDARY_EMERALD_03 = 'AccentSecondaryEmerald03',
  ACCENT_SECONDARY_EMERALD_04 = 'AccentSecondaryEmerald04',
  ACCENT_SECONDARY_BRONZE_01 = 'AccentSecondaryBronze01',
  ACCENT_SECONDARY_BRONZE_02 = 'AccentSecondaryBronze02',
  ACCENT_SECONDARY_BRONZE_03 = 'AccentSecondaryBronze03',
  ACCENT_SECONDARY_BRONZE_04 = 'AccentSecondaryBronze04',

  TRANSPARENT = 'Transparent',
}

export const themeColors: Record<ColorVariant, string> = {
  [ColorVariant.ACCENT_BLUE_1]: '#003482',
  [ColorVariant.ACCENT_BLUE_2]: '#0041A0',
  [ColorVariant.BLUE_1]: '#1976d2',
  [ColorVariant.LIGHT_BLUE_1]: '#CCD6E2',
  [ColorVariant.LIGHT_BLUE_2]: '#CCD9EC',
  [ColorVariant.BLUE_3_NA]: 'rgba(24, 94, 197, 0.2)',
  [ColorVariant.ACCENT_RED_1]: '#FF0000',
  [ColorVariant.RED_2_NA]: 'rgba(197, 24, 24, 0.2)',
  [ColorVariant.ACCENT_GREEN_1]: '#00A02D',
  [ColorVariant.GRAY_1]: '#FEFEFE',
  [ColorVariant.SECONDARY_GRAY_1]: '#F4F4F4',
  [ColorVariant.SECONDARY_GRAY_2]: '#E9E9E9',
  [ColorVariant.SECONDARY_GRAY_3]: '#DEDEDE',
  [ColorVariant.SECONDARY_GRAY_4]: '#BCBCBC',
  [ColorVariant.SECONDARY_GRAY_5]: '#979191',
  [ColorVariant.SECONDARY_GRAY_9]: '#53565A',
  [ColorVariant.SECONDARY_GRAY_10_NA]: '#E5ECF5',
  [ColorVariant.SECONDARY_GRAY_11_NA]: '#A0B9DC',
  [ColorVariant.SECONDARY_GRAY_12]: '#828897',
  [ColorVariant.PRIMARY_WHITE]: '#FFFFFF',
  [ColorVariant.PRIMARY_STEEL]: '#909090',
  [ColorVariant.PRIMARY_BLACK]: '#222222',
  [ColorVariant.PRIMARY_BLUE_100]: '#002F6C',
  [ColorVariant.ALERT_SUCCESS]: '#1EB76E',
  [ColorVariant.BACKGROUND_FILL_LIGHT]: '#FBFBFB',
  [ColorVariant.CARD_BORDER_COLOR]: 'rgba(25, 25, 25, 0.2)',
  [ColorVariant.OVERLAY_BACKGROUND]: 'rgba(0, 12, 27, 0.64)',
  // новые цвета редизайна
  [ColorVariant.SURFACE_BACKGROUND_PRIMARY]: '#FFFFFF',
  [ColorVariant.SURFACE_BACKGROUND_SECONDARY]: '#F4F4F4',
  [ColorVariant.BORDER_PRIMARY]: '#F4F4F4',
  [ColorVariant.BORDER_SECONDARY]: '#E9E9E9',
  [ColorVariant.BORDER_TERTIARY]: '#DEDEDE',
  [ColorVariant.BORDER_PASTEL_BLUE_PRIMARY_2]: '#D9E0E8',
  [ColorVariant.BORDER_PASTEL_BLUE_SECONDARY_2]: '#C8D2E0',
  [ColorVariant.BORDER_PASTEL_BLUE_TERTIARY_2]: '#B5C0D0',
  [ColorVariant.BORDER_BLUE]: '#0041A0',
  [ColorVariant.BORDER_RED]: '#FF0000',
  [ColorVariant.TEXT_NEUTRAL_TEXT_100]: '#111111',
  [ColorVariant.TEXT_NEUTRAL_TEXT_50]: '#A6A6A6',
  [ColorVariant.TEXT_ACCENT_RED_100]: '#FF0000',
  [ColorVariant.TEXT_ACCENT_RED_50]: '#BF1D26',
  [ColorVariant.TEXT_ACCENT_GREEN_100]: '#27AE60',
  [ColorVariant.TEXT_ACCENT_GREEN_50]: '#1DBF61',
  [ColorVariant.TEXT_ACCENT_BLUE_COBALT_100]: '#0041A0',
  [ColorVariant.TEXT_ACCENT_BLUE_COBALT_50]: '#3367B3',
  [ColorVariant.TEXT_PERMANENT_BLACK]: '#111111',
  [ColorVariant.TEXT_PERMANENT_GRAY]: '#D3D3D3',
  [ColorVariant.TEXT_PERMANENT_WHITE]: '#EDEDED',
  [ColorVariant.TEXT_PerMANENT_BLUE]: '#0041A0',
  [ColorVariant.NEUTRAL_PRIMARY]: '#EDEDED',
  [ColorVariant.NEUTRAL_SECONDARY]: '#111111',
  [ColorVariant.NEUTRAL_GREY_100]:'#A6A6A6',
  [ColorVariant.NEUTRAL_GREY_85]: '#BCBCBC',
  [ColorVariant.NEUTRAL_GREY_60]: '#D3D3D3',
  [ColorVariant.NEUTRAL_GREY_45]: '#DEDEDE',
  [ColorVariant.NEUTRAL_GREY_30]: '#E9E9E9',
  [ColorVariant.NEUTRAL_GREY_15]: '#F4F4F4',
  [ColorVariant.NEUTRAL_BLUE_01]: '#ECF0F4',
  [ColorVariant.NEUTRAL_BLUE_02]: '#E1E7EF',
  [ColorVariant.NEUTRAL_BLUE_03]: '#B9C4D1',
  [ColorVariant.ACCENT_PRIMARY_BLUE_PRIMARY_01]: '#002F6C',
  [ColorVariant.ACCENT_PRIMARY_BLUE_PRIMARY_02]: '#33598A',
  [ColorVariant.ACCENT_PRIMARY_BLUE_PRIMARY_03]: '#6682A6',
  [ColorVariant.ACCENT_PRIMARY_BLUE_PRIMARY_04]: '#99ACC4',
  [ColorVariant.ACCENT_PRIMARY_BLUE_PRIMARY_05]: '#CCD6E2',
  [ColorVariant.ACCENT_PRIMARY_BLUE_COBOLT_01]: '#0041A0',
  [ColorVariant.ACCENT_PRIMARY_BLUE_COBOLT_02]: '#3367B3',
  [ColorVariant.ACCENT_PRIMARY_BLUE_COBOLT_03]: '#668DC6',
  [ColorVariant.ACCENT_PRIMARY_BLUE_COBOLT_04]: '#99B3D8',
  [ColorVariant.ACCENT_PRIMARY_BLUE_COBOLT_05]: '#CCD9EC',
  [ColorVariant.ACCENT_PRIMARY_BLUE_MIDNIGHT_01]: '#001E46',
  [ColorVariant.ACCENT_PRIMARY_BLUE_MIDNIGHT_02]: '#334B6B',
  [ColorVariant.ACCENT_PRIMARY_BLUE_MIDNIGHT_03]: '#667890',
  [ColorVariant.ACCENT_PRIMARY_BLUE_MIDNIGHT_04]: '#99A5B5',
  [ColorVariant.ACCENT_PRIMARY_BLUE_MIDNIGHT_05]: '#CCD2DA',
  [ColorVariant.ACCENT_PRIMARY_RED_PRIMARY]: '#FF0000',
  [ColorVariant.ACCENT_PRIMARY_RED_SECONDARY]: '#BF1D26',
  [ColorVariant.ACCENT_PRIMARY_GREEN]: '#27AE60',
  [ColorVariant.ACCENT_PRIMARY_ORANGE]: '#E79600',
  [ColorVariant.ACCENT_SECONDARY_BURGUNDY_01]: '#6F263D',
  [ColorVariant.ACCENT_SECONDARY_BURGUNDY_02]: '#8C5164',
  [ColorVariant.ACCENT_SECONDARY_BURGUNDY_03]: '#A97D8B',
  [ColorVariant.ACCENT_SECONDARY_BURGUNDY_04]: '#C6A8B1',
  [ColorVariant.ACCENT_SECONDARY_LAVENDER_01]: '#523178',
  [ColorVariant.ACCENT_SECONDARY_LAVENDER_02]: '#745B92',
  [ColorVariant.ACCENT_SECONDARY_LAVENDER_03]: '#9783AE', 
  [ColorVariant.ACCENT_SECONDARY_LAVENDER_04]: '#BAACC9',
  [ColorVariant.ACCENT_SECONDARY_EMERALD_01]: '#00635B',
  [ColorVariant.ACCENT_SECONDARY_EMERALD_02]: '#33827B',
  [ColorVariant.ACCENT_SECONDARY_EMERALD_03]: '#65A09B',
  [ColorVariant.ACCENT_SECONDARY_EMERALD_04]: '#99C0BD',
  [ColorVariant.ACCENT_SECONDARY_BRONZE_01]: '#696158',
  [ColorVariant.ACCENT_SECONDARY_BRONZE_02]: '#8A827A',
  [ColorVariant.ACCENT_SECONDARY_BRONZE_03]: '#A5A09B',
  [ColorVariant.ACCENT_SECONDARY_BRONZE_04]: '#C3C0BC',

  [ColorVariant.TRANSPARENT]: 'transparent',
}

export enum FontVariant {
  GRTSK_PETA_ITALIC = 'GrtskPetaItalic',
  GRTSK_PETA_REGULAR = 'GrtskPetaRegular',
  GRTSK_PETA_BOLD = 'GrtskPetaBold',
  GRTSK_PETA_MEDIUM = 'GrtskPetaMedium',
}

export const themeFonts: Record<FontVariant, string> = {
  [FontVariant.GRTSK_PETA_ITALIC]: 'GrtskPeta Italic',
  [FontVariant.GRTSK_PETA_REGULAR]: 'GrtskPeta Regular',
  [FontVariant.GRTSK_PETA_BOLD]: 'GrtskPeta Bold',
  [FontVariant.GRTSK_PETA_MEDIUM]: 'GrtskPeta Medium',
}

export type Typo = {
  fontFamily: string;
  fontSize: number;
  fontWeight?: number;
  textDecoration?: string;
  lineHeight?: number;
}

export enum TypoVariant {
  GRTSKREG_W400_S08_LH10 = 'GRTSKREG_W400_S08_LH10',
  GRTSKREG_W400_S09_LH20 = 'GRTSKREG_W400_S09_LH20',
  GRTSKREG_W400_S10_LH12 = 'GRTSKREG_W400_S10_LH12',
  GRTSKREG_W400_S10_LH16 = 'GRTSKREG_W400_S10_LH16',
  GRTSKREG_W400_S11_LH14 = 'GRTSKREG_W400_S11_LH14',
  GRTSKREG_W400_S11_LH18 = 'GRTSKREG_W400_S11_LH18',
  GRTSKREG_W400_S12_LH14 = 'GRTSKREG_W400_S12_LH14',
  GRTSKREG_W400_S12_LH16 = 'GRTSKREG_W400_S12_LH16',
  GRTSKREG_W400_S12_LH18 = 'GRTSKREG_W400_S12_LH18',
  GRTSKREG_W400_S12_LH22 = 'GRTSKREG_W400_S12_LH22',
  GRTSKREG_W400_S12_LH32 = 'GRTSKREG_W400_S12_LH32',
  GRTSKREG_W400_S13_LH16 = 'GRTSKREG_W400_S13_LH16',
  GRTSKREG_W400_S13_LH20 = 'GRTSKREG_W400_S13_LH20',
  GRTSKREG_W400_S14_LH16 = 'GRTSKREG_W400_S14_LH16',
  GRTSKREG_W400_S14_LH17 = 'GRTSKREG_W400_S14_LH17',
  GRTSKREG_W400_S14_LH18 = 'GRTSKREG_W400_S14_LH18',
  GRTSKREG_W400_S14_LH20 = 'GRTSKREG_W400_S14_LH20',
  GRTSKREG_W400_S15_LH20 = 'GRTSKREG_W400_S15_LH20',
  GRTSKREG_W400_S15_LH22 = 'GRTSKREG_W400_S15_LH22',
  GRTSKREG_W400_S15_LH23 = 'GRTSKREG_W400_S15_LH23',
  GRTSKREG_W400_S15_LH28 = 'GRTSKREG_W400_S15_LH28',
  GRTSKREG_W400_S16_LH20 = 'GRTSKREG_W400_S16_LH20',
  GRTSKREG_W400_S16_LH21 = 'GRTSKREG_W400_S16_LH21',
  GRTSKREG_W400_S16_LH22 = 'GRTSKREG_W400_S16_LH22',
  GRTSKREG_W400_S16_LH24 = 'GRTSKREG_W400_S16_LH24',
  GRTSKREG_W400_S17_LH19 = 'GRTSKREG_W400_S17_LH19',
  GRTSKREG_W400_S20_LH20 = 'GRTSKREG_W400_S20_LH20',
  GRTSKREG_W400_S20_LH24 = 'GRTSKREG_W400_S20_LH24',
  GRTSKREG_W400_S20_LH28 = 'GRTSKREG_W400_S20_LH28',
  GRTSKREG_W400_S24_LH24 = 'GRTSKREG_W400_S24_LH24',
  GRTSKREG_W500_S16_LH24 = 'GRTSKREG_W500_S16_LH24',
  GRTSKREG_W500_S16_LH22 = 'GRTSKREG_W500_S16_LH22',
  GRTSKREG_W600_S12_LH16 = 'GRTSKREG_W600_S12_LH16',
  GRTSKREG_W600_S12_LH18 = 'GRTSKREG_W600_S12_LH18',
  GRTSKREG_W600_S14_LH17 = 'GRTSKREG_W600_S14_LH17',
  GRTSKREG_W600_S15_LH20 = 'GRTSKREG_W600_S15_LH20',
  GRTSKREG_W500_S12_LH16 = 'GRTSKREG_W500_S12_LH16',
  GRTSKREG_W500_S12_LH21 = 'GRTSKREG_W500_S12_LH21',
  GRTSKREG_W500_S14_LH18 = 'GRTSKREG_W500_S14_LH18',
  GRTSKREG_W500_S18_LH22 = 'GRTSKREG_W500_S18_LH22',
  GRTSKREG_W600_S18_LH24 = 'GRTSKREG_W600_S18_LH24',
  GRTSKREG_W600_S18_LH26 = 'GRTSKREG_W600_S18_LH26',
  GRTSKREG_W600_S18_LH28 = 'GRTSKREG_W600_S18_LH28',
  GRTSKREG_W600_S26_LH35 = 'GRTSKREG_W600_S26_LH35',
  GRTSKREG_W600_S28_LH24 = 'GRTSKREG_W600_S28_LH24',
  GRTSKREG_W600_S28_LH32 = 'GRTSKREG_W600_S28_LH32',
  GRTSKREG_W600_S32_LH43 = 'GRTSKREG_W600_S32_LH43',
}

export const themeTypos: Record<TypoVariant, Typo> = {
  [TypoVariant.GRTSKREG_W400_S08_LH10]: {
    fontFamily: themeFonts.GrtskPetaRegular,
    fontSize: 8,
    fontWeight: 400,
    lineHeight: 10,
  },
  [TypoVariant.GRTSKREG_W400_S09_LH20]: {
    fontFamily: themeFonts.GrtskPetaRegular,
    fontSize: 9,
    fontWeight: 400,
    lineHeight: 20,
  },
  [TypoVariant.GRTSKREG_W400_S10_LH12]: {
    fontFamily: themeFonts.GrtskPetaRegular,
    fontSize: 10,
    fontWeight: 400,
    lineHeight: 12,
  },
  [TypoVariant.GRTSKREG_W400_S10_LH16]: {
    fontFamily: themeFonts.GrtskPetaRegular,
    fontSize: 10,
    fontWeight: 400,
    lineHeight: 16,
  },
  [TypoVariant.GRTSKREG_W400_S11_LH14]: {
    fontFamily: themeFonts.GrtskPetaRegular,
    fontSize: 11,
    fontWeight: 400,
    lineHeight: 14,
  },
  [TypoVariant.GRTSKREG_W400_S11_LH18]: {
    fontFamily: themeFonts.GrtskPetaRegular,
    fontSize: 11,
    fontWeight: 400,
    lineHeight: 18,
  },
  [TypoVariant.GRTSKREG_W400_S12_LH14]: {
    fontFamily: themeFonts.GrtskPetaRegular,
    fontSize: 12,
    fontWeight: 400,
    lineHeight: 14,
  },
  [TypoVariant.GRTSKREG_W400_S12_LH16]: {
    fontFamily: themeFonts.GrtskPetaRegular,
    fontSize: 12,
    fontWeight: 400,
    lineHeight: 16,
  },
  [TypoVariant.GRTSKREG_W400_S12_LH18]: {
    fontFamily: themeFonts.GrtskPetaRegular,
    fontSize: 12,
    fontWeight: 400,
    lineHeight: 18,
  },
  [TypoVariant.GRTSKREG_W400_S12_LH22]: {
    fontFamily: themeFonts.GrtskPetaRegular,
    fontSize: 12,
    fontWeight: 400,
    lineHeight: 22,
  },
  [TypoVariant.GRTSKREG_W400_S12_LH32]: {
    fontFamily: themeFonts.GrtskPetaRegular,
    fontSize: 12,
    fontWeight: 400,
    lineHeight: 32,
  },
  [TypoVariant.GRTSKREG_W400_S13_LH16]: {
    fontFamily: themeFonts.GrtskPetaRegular,
    fontSize: 13,
    fontWeight: 400,
    lineHeight: 16,
  },
  [TypoVariant.GRTSKREG_W400_S13_LH20]: {
    fontFamily: themeFonts.GrtskPetaRegular,
    fontSize: 13,
    fontWeight: 400,
    lineHeight: 20,
  },
  [TypoVariant.GRTSKREG_W400_S14_LH16]: {
    fontFamily: themeFonts.GrtskPetaRegular,
    fontSize: 14,
    fontWeight: 400,
    lineHeight: 16,
  },
  [TypoVariant.GRTSKREG_W400_S14_LH17]: {
    fontFamily: themeFonts.GrtskPetaRegular,
    fontSize: 14,
    fontWeight: 400,
    lineHeight: 17,
  },
  [TypoVariant.GRTSKREG_W400_S14_LH18]: {
    fontFamily: themeFonts.GrtskPetaRegular,
    fontSize: 14,
    fontWeight: 400,
    lineHeight: 18,
  },
  [TypoVariant.GRTSKREG_W400_S14_LH20]: {
    fontFamily: themeFonts.GrtskPetaRegular,
    fontSize: 14,
    fontWeight: 400,
    lineHeight: 20,
  },
  [TypoVariant.GRTSKREG_W400_S15_LH20]: {
    fontFamily: themeFonts.GrtskPetaRegular,
    fontSize: 15,
    fontWeight: 400,
    lineHeight: 20,
  },
  [TypoVariant.GRTSKREG_W400_S15_LH22]: {
    fontFamily: themeFonts.GrtskPetaRegular,
    fontSize: 15,
    fontWeight: 400,
    lineHeight: 22,
  },
  [TypoVariant.GRTSKREG_W400_S15_LH23]: {
    fontFamily: themeFonts.GrtskPetaRegular,
    fontSize: 15,
    fontWeight: 400,
    lineHeight: 23,
  },
  [TypoVariant.GRTSKREG_W400_S15_LH28]: {
    fontFamily: themeFonts.GrtskPetaRegular,
    fontSize: 15,
    fontWeight: 400,
    lineHeight: 28,
  },
  [TypoVariant.GRTSKREG_W400_S16_LH20]: {
    fontFamily: themeFonts.GrtskPetaRegular,
    fontSize: 16,
    fontWeight: 400,
    lineHeight: 20,
  },
  [TypoVariant.GRTSKREG_W400_S16_LH21]: {
    fontFamily: themeFonts.GrtskPetaRegular,
    fontSize: 16,
    fontWeight: 400,
    lineHeight: 21,
  },
  [TypoVariant.GRTSKREG_W400_S16_LH22]: {
    fontFamily: themeFonts.GrtskPetaRegular,
    fontSize: 16,
    fontWeight: 400,
    lineHeight: 22,
  },
  [TypoVariant.GRTSKREG_W400_S16_LH24]: {
    fontFamily: themeFonts.GrtskPetaRegular,
    fontSize: 16,
    fontWeight: 400,
    lineHeight: 24,
  },
  [TypoVariant.GRTSKREG_W400_S17_LH19]: {
    fontFamily: themeFonts.GrtskPetaRegular,
    fontSize: 17,
    fontWeight: 400,
    lineHeight: 19,
  },
  [TypoVariant.GRTSKREG_W400_S20_LH20]: {
    fontFamily: themeFonts.GrtskPetaRegular,
    fontSize: 20,
    fontWeight: 400,
    lineHeight: 20,
  },
  [TypoVariant.GRTSKREG_W400_S20_LH24]: {
    fontFamily: themeFonts.GrtskPetaRegular,
    fontSize: 20,
    fontWeight: 400,
    lineHeight: 24,
  },
  [TypoVariant.GRTSKREG_W400_S20_LH28]: {
    fontFamily: themeFonts.GrtskPetaRegular,
    fontSize: 20,
    fontWeight: 400,
    lineHeight: 28,
  },
  [TypoVariant.GRTSKREG_W400_S24_LH24]: {
    fontFamily: themeFonts.GrtskPetaRegular,
    fontSize: 24,
    fontWeight: 400,
    lineHeight: 24,
  },
  [TypoVariant.GRTSKREG_W500_S16_LH24]: {
    fontFamily: themeFonts.GrtskPetaMedium,
    fontSize: 16,
    fontWeight: 500,
    lineHeight: 24,
  },
  [TypoVariant.GRTSKREG_W500_S16_LH22]: {
    fontFamily: themeFonts.GrtskPetaMedium,
    fontSize: 16,
    fontWeight: 500,
    lineHeight: 22,
  },
  [TypoVariant.GRTSKREG_W600_S12_LH16]: {
    fontFamily: themeFonts.GrtskPetaRegular,
    fontSize: 12,
    fontWeight: 600,
    lineHeight: 16,
  },
  [TypoVariant.GRTSKREG_W600_S12_LH18]: {
    fontFamily: themeFonts.GrtskPetaRegular,
    fontSize: 12,
    fontWeight: 600,
    lineHeight: 18,
  },
  [TypoVariant.GRTSKREG_W600_S14_LH17]: {
    fontFamily: themeFonts.GrtskPetaRegular,
    fontSize: 14,
    fontWeight: 600,
    lineHeight: 17,
  },
  [TypoVariant.GRTSKREG_W600_S15_LH20]: {
    fontFamily: themeFonts.GrtskPetaRegular,
    fontSize: 15,
    fontWeight: 600,
    lineHeight: 20,
  },
  [TypoVariant.GRTSKREG_W600_S18_LH24]: {
    fontFamily: themeFonts.GrtskPetaRegular,
    fontSize: 18,
    fontWeight: 600,
    lineHeight: 24,
  },
  [TypoVariant.GRTSKREG_W500_S12_LH16]: {
    fontFamily: themeFonts.GrtskPetaRegular,
    fontSize: 12,
    fontWeight: 500,
    lineHeight: 16,
  },
  [TypoVariant.GRTSKREG_W500_S12_LH21]: {
    fontFamily: themeFonts.GrtskPetaRegular,
    fontSize: 12,
    fontWeight: 500,
    lineHeight: 21,
  },
  [TypoVariant.GRTSKREG_W500_S14_LH18]: {
    fontFamily: themeFonts.GrtskPetaRegular,
    fontSize: 14,
    fontWeight: 500,
    lineHeight: 18,
  },
  [TypoVariant.GRTSKREG_W500_S18_LH22]: {
    fontFamily: themeFonts.GrtskPetaRegular,
    fontSize: 18,
    fontWeight: 500,
    lineHeight: 22,
  },
  [TypoVariant.GRTSKREG_W600_S18_LH26]: {
    fontFamily: themeFonts.GrtskPetaRegular,
    fontSize: 18,
    fontWeight: 600,
    lineHeight: 26,
  },
  [TypoVariant.GRTSKREG_W600_S18_LH28]: {
    fontFamily: themeFonts.GrtskPetaRegular,
    fontSize: 18,
    fontWeight: 600,
    lineHeight: 28,
  },
  [TypoVariant.GRTSKREG_W600_S26_LH35]: {
    fontFamily: themeFonts.GrtskPetaRegular,
    fontSize: 26,
    fontWeight: 600,
    lineHeight: 35,
  },
  [TypoVariant.GRTSKREG_W600_S28_LH24]: {
    fontFamily: themeFonts.GrtskPetaRegular,
    fontSize: 28,
    fontWeight: 600,
    lineHeight: 24,
  },
  [TypoVariant.GRTSKREG_W600_S28_LH32]: {
    fontFamily: themeFonts.GrtskPetaRegular,
    fontSize: 28,
    fontWeight: 600,
    lineHeight: 32,
  },
  [TypoVariant.GRTSKREG_W600_S32_LH43]: {
    fontFamily: themeFonts.GrtskPetaRegular,
    fontSize: 32,
    fontWeight: 600,
    lineHeight: 43,
  },
}

export const typoAsCSS = (typo: Typo): string => {
  return `
    font-family: ${typo.fontFamily};
    font-size: ${typo.fontSize}px;
    ${typo.fontWeight !== undefined ? 'font-weight: ' + typo.fontWeight + ';' : ''}
    ${typo.textDecoration !== undefined ? 'text-decoration: ' + typo.textDecoration + ';' : ''}
    ${typo.lineHeight !== undefined ? 'line-height: ' + typo.lineHeight + 'px;' : ''}
  `;
}

/**
 * Общие куски CSS, которые часто повторяются при описании компонентов,
 * и которые можно потом вставить в styled-компонент
 * https://styled-components.com/docs/api#css
 */
 export const cssFlexRow = css`
 display: flex;
 flex-direction: row;
`;

 export const cssFlexReverseRow = css`
 display: flex;
 flex-direction: row-reverse;
`;

export const cssFlexRowCC = css`
 display: flex;
 flex-direction: row;
 justify-content: center;
 align-items: center;
`;

export const cssFlexColumn = css`
 display: flex;
 flex-direction: column;
`;


/**
 * Breakpoint-ы для медиа запросов
 */
export const MQ = generateMedia({
  mobileS: '320px',
  mobileM: '375px',
  mobileL: '425px',
  tablet: '768px',
  laptop: '1024px',
  laptopL: '1440px',
  desktop: '2560px',
});
